import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAPIURL } from "helpers";
import { getBaseQueryWithRejection } from "redux/helper.redux";

const baseQueryWithRejection = getBaseQueryWithRejection(
    fetchBaseQuery({
        baseUrl: getAPIURL("/api/mission-expert"),
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.accessToken;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })
);

export const missionExpertsApi = createApi({
    reducerPath: "missionExpertsApi",
    baseQuery: baseQueryWithRejection,
    tagTypes: [],
    endpoints: (builder) => ({
        getMissionExperts: builder.query({
            query: (params) => {
                const tmp = new URLSearchParams();
                if (params.missionId) tmp.append('mission_id', params.missionId);
                if (params.attributes) tmp.append('attributes', params.attributes);
                if (params.responseStatus) tmp.append('response_status', params.responseStatus);
                return `?${tmp.toString()}`;
            },
            transformResponse: (response) => response.data,
            providesTags: ["MissionExpert"]
        }),
    }),
});

export const { useGetMissionExpertsQuery } = missionExpertsApi;
